import { forwardRef } from "preact/compat";
import classnames from 'classnames';
import { jsx as _jsx } from "preact/compat/jsx-runtime";
export const Tab = forwardRef((props, ref) => {
  const defaultProps = {
    selected: false
  };
  const href = props.href || `#${props.panelId}`;
  const classes = classnames('ds-c-tabs__item', props.className);
  const sharedTabProps = {
    role: 'tab',
    className: classes,
    id: props.id,
    ref: ref
  };
  const handleClick = evt => {
    const {
      onClick,
      panelId,
      id
    } = props;
    if (onClick) {
      onClick(evt, panelId, id, href);
    }
  };
  const handleKeyDown = evt => {
    const {
      onKeyDown,
      panelId,
      id
    } = props;
    if (onKeyDown) {
      onKeyDown(evt, panelId, id, href);
    }
  };
  return !props.disabled ? /*#__PURE__*/_jsx("a", {
    "aria-selected": props.selected || defaultProps.selected,
    "aria-controls": props.panelId,
    href: href,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ...sharedTabProps,
    children: props.children
  }) : /*#__PURE__*/_jsx("span", {
    "aria-disabled": "true",
    ...sharedTabProps,
    children: props.children
  });
});
Tab.displayName = 'Tab';
export default Tab;